<!-- チケット一覧の追加取得でAPIエラーになった場合 -->
<template>
  <ItemDialog ref="getMyticketsError" image-type="alert">
    <template #content-area>
      <p>チケット情報の取得に失敗しました。もう一度お試しください。</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogGetMyticketsError",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const getMyticketsError = ref(null);

    const openDialog = () => {
      getMyticketsError.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        getMyticketsError.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      getMyticketsError,
      openDialog,
      closeDialog,
    };
  },
};
</script>
